<template>
    <navigation />

    <promo-header />

    <section class="section section-blue">

        <div class="container">

            <div class="row">

                <div class="col-lg-8">

                    <h2 class="mb-4">
                        Abraham
                    </h2>

                    <h5>Series Aims</h5>

                    <ul>
                        <li>
                            To understand the call of Abraham as God's gracious response to the world's rebellion at Babel.
                        </li>
                        <li>
                            To see how God's dealings with Abraham formed the basis of his rescue plan for the world.
                        </li>
                        <li>
                            To understand the nature of faith as it is illustrated in the life of Abraham.
                        </li>
                    </ul>

                    <h5 class="mt-4">Series Overview</h5>
                    <p>
                        The series traces Abraham's growing understanding of what it means to trust God despite the
                        many obstacles that appear to stand in the way of God keeping his promise.
                    </p>
                    <p>
                        There are times when Abraham takes matters into his own hands and does not fully trust God.
                        But, as always, disobedience to God's word results in pain and broken relationships and
                        Abraham learns this the hard way.
                    </p>
                    <p>
                        However, Abraham grows through these experiences and this is finally seen in his response to
                        the ultimate test of faith - his willingness to sacrifice his own son at God's command.
                    </p>
                    <p>
                        God spares Isaac's life and confirms his promise to Abraham. The threefold promise is ultimately
                        fulfilled in Jesus, the only beloved son who was not spared on the mountain, but died and
                        rose again to bring blessing to all people.
                    </p>

                    <h5 class="mt-4">Series Outline</h5>
                    <p>
                        Lesson 1 - Calling Abraham (Genesis 11:27 - 12:9)
                    </p>
                    <p>
                        Lesson 2 - Lot's Choice (Genesis 13:1-18)
                    </p>
                    <p>
                        Lesson 3 - Promises Confirmed (Genesis 15:1-21)
                    </p>
                    <p>
                        Lesson 4 - The Results of Unbelief (Genesis 16:1-15)
                    </p>
                    <p>
                        Lesson 5 - God Keeps His Promise (Genesis 17:1-8; 18:1-16; 21:1-7)
                    </p>
                    <p>
                        Lesson 6 - God Provides (Genesis 22:1-19)
                    </p>
                    <p>
                        Lesson 7 - God Guides (Genesis 24:1-67)
                    </p>

                </div>

                <div class="offset-lg-1 col">

                    <promo-sidebar />

                </div>

            </div>

        </div>

    </section>

    <site-footer />
</template>

<script >
import Navigation from "../partials/Navigation.vue";
import SiteFooter from "../partials/SiteFooter.vue";
import PromoHeader from "../partials/PromoHeader.vue";
import PromoSidebar from "../partials/PromoSidebar.vue";

export default {
    name: "Abraham",

    components: {
        PromoSidebar,
        PromoHeader,
        Navigation,
        SiteFooter,
    },

    head() {
        return {
            title: `${this.$app.appName} - Abraham`,
            meta: [
                {
                    name: 'description',
                    content: "Bible teaching about Abraham written by Mustard Seeds",
                },
            ],
        };
    },
};
</script>
